// Firebase config placeholder. Create a Firebase project and paste your config here.
export const firebaseConfig = {
   apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
   authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
   databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || '',
   projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
   storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
   messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
   appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
};

// Check if Firebase is properly configured
export const hasFirebaseConfig = (() => {
    if (!firebaseConfig) return false;
    const required = [firebaseConfig.apiKey, firebaseConfig.databaseURL, firebaseConfig.projectId];
    return required.every(v => typeof v === 'string' && v.length > 0 && !v.includes('REPLACE_ME'));
})();
